var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Box, Flex, Text, ChatMessageSeparator, Button } from 'pcln-design-system';
import React, { useContext, useEffect, useRef } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { DialogInputSection } from './DialogInputSection';
import { submitChatMessages } from './submitChatMessages';
import { ScrollIntoView } from './ScrollIntoView';
import { DialogLoading } from './DialogLoading';
import { TravelBotChatSingleDialogGeneric } from './TravelBotChatSingleDialogGeneric';
import { QuickActions } from './QuickActions';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { submitMessageToLivePerson } from './LivePersonService/submitLivePersonMessage';
import { livePersonMessagesStatusManager } from './LivePersonService/livePersonMessageStatusManager';
import { EVENT_TYPE, MESSAGE_TYPE } from './LivePersonService/constantsLivePerson';
import { HotelDetailCardsMessage } from './HotelComponent/HotelDetailCard';
import { SelectedFiltersOptions } from './HotelComponent/SelectedFiltersOptions';
import { BlockingInputComponent } from './BlockingInputComponent';
import Trips from './components/Trips/Trips';
import ErrorComponent from './components/ErrorComponent';
import SignOutActions from './components/SignOutActions/SignOutActions';
import HandleSetiActions from './components/HandleSetiActions';
/**
 * ChatDialogMainContentSection
 * Main chat content
 * @public
 */
export var ChatDialogMainContentSection = function () {
    var _a = useContext(ChatbotDataContext), setCachedMessages = _a.setCachedMessages, setCachedPrompts = _a.setCachedPrompts, submitChatMessagesPayload = _a.submitChatMessagesPayload, handleMarkerResponse = _a.handleMarkerResponse, fetchRequestOptions = _a.fetchRequestOptions, markerComponents = _a.markerComponents, _b = _a.livePersonOptions, livePersonOptions = _b === void 0 ? {} : _b, logFirstMessageSubmitted = _a.logFirstMessageSubmitted, errorMessage = _a.errorMessage, setErrorMessage = _a.setErrorMessage, isLoading = _a.isLoading, setLoadingStatus = _a.setLoadingStatus, chatMessages = _a.chatMessages, setChatMessage = _a.setChatMessage, prompts = _a.prompts, setPrompts = _a.setPrompts, isDisablingInput = _a.isDisablingInput, setIsDisablingInputValue = _a.setIsDisablingInputValue, fullStreamingTexts = _a.fullStreamingTexts, setStreamingText = _a.setStreamingText, livePersonConversationId = _a.livePersonConversationId, livePersonConnectionRequest = _a.livePersonConnectionRequest, lpUserFirstName = _a.lpUserFirstName, setLPUserFirstName = _a.setLPUserFirstName, lpUserLastName = _a.lpUserLastName, setLPUserLastName = _a.setLPUserLastName, isLPUserFormSubmitted = _a.isLPUserFormSubmitted, setIsLPUserFormSubmitted = _a.setIsLPUserFormSubmitted, isLivePersonEnabled = _a.isLivePersonEnabled, setIsLivePersonEnabled = _a.setIsLivePersonEnabled, setChatSummary = _a.setChatSummary, debugMode = _a.debugMode, discoveryCitySelected = _a.discoveryCitySelected, pushPrompt = _a.pushPrompt, setOpenErrorComponent = _a.setOpenErrorComponent, openErrorComponent = _a.openErrorComponent;
    var contentRef = useRef(null);
    useEffect(function () {
        contentRef.current.scrollTop = 0;
    }, []);
    var submitChatMessagesOptions = {
        setChatMessage: setChatMessage,
        setPrompts: setPrompts,
        setStreamingText: setStreamingText,
        setLoadingStatus: setLoadingStatus,
        setErrorMessage: setErrorMessage,
        setIsDisablingInputValue: setIsDisablingInputValue,
        // Cache control
        cacheControl: {
            setCachedMessages: setCachedMessages,
            setCachedPrompts: setCachedPrompts,
        },
        requestOptions: fetchRequestOptions,
        markerComponents: markerComponents,
        handleMarkerResponse: handleMarkerResponse,
    };
    useEffect(function () {
        if (discoveryCitySelected || pushPrompt) {
            var chatContent = discoveryCitySelected
                ? "Looking for hotels in ".concat(discoveryCitySelected)
                : pushPrompt;
            var chatMessage = {
                content: chatContent,
                date: new Date(),
                role: 'user',
            };
            var promptMessage = {
                content: chatContent,
                role: 'user',
            };
            var updatedChatMessages = __spreadArray(__spreadArray([], chatMessages, true), [chatMessage], false);
            //  set user's message
            setChatMessage(updatedChatMessages);
            setCachedMessages(chatMessage);
            setCachedPrompts(promptMessage);
            // submit user's message to get response
            submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [promptMessage], false) }), setOpenErrorComponent: setOpenErrorComponent, 
                // Local state control
                chatMessages: updatedChatMessages }, submitChatMessagesOptions));
        }
    }, [discoveryCitySelected, pushPrompt]);
    var submitMessageURL = livePersonOptions.submitMessageURL, handleLivePersonOnMessageError = livePersonOptions.handleLivePersonOnMessageError, chatCustomerId = livePersonOptions.chatCustomerId;
    // Auto submit the first message to init the conversation with ChatBot
    useEffect(function () {
        if (chatMessages.length === 0 && !isLivePersonEnabled) {
            submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: prompts }), setOpenErrorComponent: setOpenErrorComponent, chatMessages: chatMessages }, submitChatMessagesOptions));
        }
    }, [chatMessages.length === 0]);
    function submitChatMessageInMarkerComponent(msg, updatedChatMessage) {
        submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [msg], false) }), setOpenErrorComponent: setOpenErrorComponent, 
            // Local state control
            chatMessages: !Array.isArray(updatedChatMessage) || updatedChatMessage.length === 0
                ? chatMessages
                : updatedChatMessage }, submitChatMessagesOptions));
    }
    if (openErrorComponent) {
        return React.createElement(ErrorComponent, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { width: 1, height: 'calc(100% - 120px)', style: { position: 'absolute', top: '65px', overflowY: 'scroll', overflowX: 'hidden' }, ref: contentRef },
            React.createElement(Flex, { p: 3, width: 1, minHeight: '100%', flexDirection: 'column', justifyContent: 'flex-end' },
                chatMessages.map(function (m, i) {
                    var _a, _b;
                    var hasOtherMessageHandler = function (m, chatMessage) {
                        var mappedChatMessage = chatMessage.map(function (result) { return JSON.stringify(result); });
                        var index = mappedChatMessage.indexOf(JSON.stringify(m));
                        return chatMessage.length - 1 > index;
                    };
                    // Display a predefined Marker Component
                    if (markerComponents[m === null || m === void 0 ? void 0 : m.displayComponentName] &&
                        typeof markerComponents[m === null || m === void 0 ? void 0 : m.displayComponentName] === 'function') {
                        var Marker = markerComponents[m.displayComponentName];
                        var markeComponentProps = (m === null || m === void 0 ? void 0 : m.markerComponentProps) || {};
                        var markerProps = __assign(__assign({}, markeComponentProps), { message: m, isLoading: isLoading, setIsDisablingInputValue: setIsDisablingInputValue, chatMessages: chatMessages, setChatMessage: setChatMessage, submitMessages: submitChatMessageInMarkerComponent, livePersonConnectionRequest: livePersonConnectionRequest, setLPUserFirstName: setLPUserFirstName, setLPUserLastName: setLPUserLastName, lpUserFirstName: lpUserFirstName, lpUserLastName: lpUserLastName, isLPUserFormSubmitted: isLPUserFormSubmitted, setIsLPUserFormSubmitted: setIsLPUserFormSubmitted, isLivePersonEnabled: isLivePersonEnabled, setIsLivePersonEnabled: setIsLivePersonEnabled, submitChatSummary: setChatSummary });
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(m.content) },
                            React.createElement(Marker, __assign({}, markerProps))));
                    }
                    if (m.role === 'chatContentSeparator') {
                        var content = m.content;
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(m.key) },
                            React.createElement(Box, { mb: 4 },
                                React.createElement(ChatMessageSeparator, { message: content }))));
                    }
                    if (m.role === 'lpChatDisclosure') {
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-disclosure--".concat(i) },
                            React.createElement(Box, { mb: 4 },
                                React.createElement(Text, { color: 'text.light', textAlign: 'center', textStyle: 'subheading6' }, m.content))));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.role) && (m === null || m === void 0 ? void 0 : m.content)) {
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(i) },
                            React.createElement(TravelBotChatSingleDialogGeneric, { message: m, livePersonAgentInitial: (m === null || m === void 0 ? void 0 : m.agentInitial) || 'ag', livePersonAgentName: (m === null || m === void 0 ? void 0 : m.agentNickname) || 'agent' })));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'FIRE_SETI') {
                        return (React.createElement(React.Fragment, null,
                            React.createElement(HandleSetiActions, { setiValues: (_a = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _a === void 0 ? void 0 : _a.setiValues })));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'QUICK_ACTIONS') {
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(i) },
                            React.createElement(QuickActions, { quickActions: (_b = m === null || m === void 0 ? void 0 : m.markerComponentProps) === null || _b === void 0 ? void 0 : _b.quickActions, hasOtherMessage: hasOtherMessageHandler(m, chatMessages), submitQuickActionMessage: function (action) {
                                    var chatContent = action.chatContent, promptContent = action.promptContent;
                                    var promptMessage = {
                                        content: promptContent || chatContent,
                                        role: 'user',
                                    };
                                    var chatMessage = {
                                        content: chatContent,
                                        role: 'user',
                                    };
                                    var updatedChatMessages = __spreadArray(__spreadArray([], chatMessages, true), [chatMessage], false);
                                    // set user's message
                                    setChatMessage(updatedChatMessages);
                                    setCachedMessages(chatMessage);
                                    setCachedPrompts(promptMessage);
                                    // submit user's message to get response
                                    submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [promptMessage], false) }), setOpenErrorComponent: setOpenErrorComponent, 
                                        // Local state control
                                        chatMessages: updatedChatMessages }, submitChatMessagesOptions));
                                } })));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'HOTEL_CARDS_MARKER') {
                        return (React.createElement(React.Fragment, { key: "chat-msg-".concat(i) },
                            React.createElement(HotelDetailCardsMessage, __assign({}, m === null || m === void 0 ? void 0 : m.markerComponentProps, { setChatMessage: setChatMessage, 
                                // Submit message when user apply filter options
                                submitMessages: submitChatMessageInMarkerComponent }))));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'DISPLAY_SELECTED_HOTEL_FILTER_MARKER') {
                        return (React.createElement(React.Fragment, { key: "chat-msg-".concat(i) },
                            React.createElement(SelectedFiltersOptions, __assign({}, m === null || m === void 0 ? void 0 : m.markerComponentProps, { setChatMessage: setChatMessage, 
                                // Submit message when user apply filter options
                                submitMessages: submitChatMessageInMarkerComponent }))));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'BLOCK_INPUT_MARKER') {
                        return (React.createElement(React.Fragment, { key: "chat-msg-".concat(i) },
                            React.createElement(BlockingInputComponent, { setIsDisablingInputValue: setIsDisablingInputValue })));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'DISPLAY_MY_TRIPS') {
                        var _c = (m === null || m === void 0 ? void 0 : m.markerComponentProps) || {}, trips = _c.tripsList, tripType = _c.tripType, hasMoreTrips = _c.hasMoreTrips;
                        return (React.createElement(React.Fragment, { key: "chat-msg-".concat(i) },
                            React.createElement(Trips, { trips: trips, tripType: tripType }),
                            hasMoreTrips ? (React.createElement(Box, { my: 4, ml: 3 },
                                React.createElement(Button, { onClick: function () {
                                        window.open('/next-profile/trips');
                                    }, variation: 'subtle' }, "View All Trips"))) : null));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) === 'SHOW_SIGNED_OUT_ACTION_BUTTONS') {
                        return (React.createElement(React.Fragment, { key: "chat-msg-".concat(i) },
                            React.createElement(SignOutActions, null)));
                    }
                    if ((m === null || m === void 0 ? void 0 : m.displayComponentName) && debugMode) {
                        console.log('Debug Mode', m === null || m === void 0 ? void 0 : m.displayComponentName);
                        console.log(JSON.stringify(m, null, 2));
                        return (React.createElement(ScrollIntoView, { key: "chat-msg-".concat(i) },
                            React.createElement(Box, null,
                                React.createElement(Box, null,
                                    "Marker Component Name: ", m === null || m === void 0 ? void 0 :
                                    m.displayComponentName),
                                React.createElement(Box, null,
                                    "Check dev console for more details of ", m === null || m === void 0 ? void 0 :
                                    m.displayComponentName,
                                    " component props"))));
                    }
                }),
                errorMessage && (React.createElement(ScrollIntoView, null,
                    React.createElement(Box, { my: 3, p: 3 },
                        React.createElement(Text, { color: 'error.base' }, errorMessage),
                        React.createElement(Text, { color: 'error.base' }, "Please retry!")))),
                isLoading && ( // loading status for the bot only
                React.createElement(ScrollIntoView, null,
                    React.createElement(DialogLoading, { streamingText: fullStreamingTexts }))),
                // There is no loading status for live person, we will display whatever status text we got
                isLivePersonEnabled && fullStreamingTexts && (React.createElement(ScrollIntoView, null,
                    React.createElement(Text, { fontStyle: 'italic', color: 'text.light', px: 3 }, fullStreamingTexts))))),
        React.createElement(Box, { width: 1, style: { position: 'absolute', bottom: '0px' } },
            React.createElement(DialogInputSection, { isLivePersonEnabled: isLivePersonEnabled, 
                // from local state
                livePersonConversationId: livePersonConversationId, isDisablingInput: isDisablingInput, isLoading: isLoading, submitInputValue: function (msg) {
                    // Set the error message as empty if there is any
                    setErrorMessage('');
                    // cache the msg on local for reuse
                    var msgWithDate = __assign(__assign({}, msg), { date: new Date() });
                    setCachedMessages(msgWithDate);
                    setCachedPrompts(msg);
                    var updatedChatMessages = __spreadArray(__spreadArray([], chatMessages, true), [msgWithDate], false);
                    // Update the message showing in the dialog
                    setChatMessage(updatedChatMessages);
                    // Submit the user message
                    submitChatMessages(__assign({ submitChatMessagesPayload: __assign(__assign({}, submitChatMessagesPayload), { prompts: __spreadArray(__spreadArray([], prompts, true), [msg], false) }), setOpenErrorComponent: setOpenErrorComponent, 
                        // Local state control
                        chatMessages: updatedChatMessages }, submitChatMessagesOptions));
                    // Log first user submitted message to chatbot
                    if (chatMessages.length <= 1 &&
                        logFirstMessageSubmitted &&
                        typeof logFirstMessageSubmitted === 'function') {
                        logFirstMessageSubmitted(msg.content);
                    }
                }, submitMessageToLivePerson: function (userMessage) {
                    // Set the error message as empty if there is any
                    setErrorMessage('');
                    // disabled the input field until current message submitted
                    setIsDisablingInputValue(true);
                    // Create a user message to LP service
                    var lpData = {
                        messageType: MESSAGE_TYPE.MESSAGE,
                        conversationId: livePersonConversationId,
                        eventType: EVENT_TYPE.ContentEvent,
                        eventDesc: userMessage.content,
                    };
                    var msgId = uuidV4();
                    var livePersonMessagePayload = {
                        user: {
                            firstName: lpUserFirstName,
                            lastName: lpUserLastName,
                        },
                        lpData: lpData,
                        chatCustomerId: chatCustomerId,
                        msgId: msgId,
                    };
                    livePersonMessagesStatusManager.updateMessageStatusByMsgId(msgId, '');
                    var updatedChatMessages = __spreadArray(__spreadArray([], chatMessages, true), [
                        __assign(__assign({}, userMessage), { msgId: msgId }),
                    ], false);
                    // Update the user message showing in the dialog
                    setChatMessage(updatedChatMessages);
                    setCachedMessages(undefined, updatedChatMessages);
                    submitMessageToLivePerson({
                        requestOptions: {
                            url: submitMessageURL,
                            headers: {},
                        },
                        livePersonMessagePayload: livePersonMessagePayload,
                        handleLivePersonOnMessageError: handleLivePersonOnMessageError,
                    }).then(function (_a) {
                        var errorMessage = _a.errorMessage;
                        setIsDisablingInputValue(false);
                        if (errorMessage) {
                            setErrorMessage(errorMessage);
                        }
                        else {
                            livePersonMessagesStatusManager.updateMessageStatusByMsgId(msgId, 'SENT');
                        }
                    });
                }, submitUserChatStateEvent: function (status) {
                    var _this = this;
                    var lpData = {
                        messageType: MESSAGE_TYPE.MESSAGE,
                        conversationId: livePersonConversationId,
                        eventType: EVENT_TYPE.ChatStateEvent,
                        eventDesc: status,
                    };
                    var msgId = uuidV4();
                    var livePersonMessagePayload = {
                        lpData: lpData,
                        user: {
                            firstName: lpUserFirstName,
                            lastName: lpUserLastName,
                        },
                        chatCustomerId: chatCustomerId,
                        msgId: msgId,
                    };
                    livePersonMessagesStatusManager.updatePendingMessageStatus(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, submitMessageToLivePerson({
                                        requestOptions: {
                                            url: submitMessageURL,
                                            headers: {},
                                        },
                                        livePersonMessagePayload: livePersonMessagePayload,
                                        handleLivePersonOnMessageError: handleLivePersonOnMessageError,
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }, submitUserAcceptStatusEvent: function (status) {
                    var _this = this;
                    var sequenceList = livePersonMessagesStatusManager.getPendingAgentSequenceIds();
                    if (sequenceList.length === 0) {
                        return;
                    }
                    var lpData = {
                        messageType: MESSAGE_TYPE.MESSAGE,
                        conversationId: livePersonConversationId,
                        eventType: EVENT_TYPE.AcceptStatusEvent,
                        eventDesc: status,
                        sequenceList: livePersonMessagesStatusManager.getPendingAgentSequenceIds(),
                    };
                    var msgId = uuidV4();
                    var livePersonMessagePayload = {
                        lpData: lpData,
                        user: {
                            firstName: lpUserFirstName,
                            lastName: lpUserLastName,
                        },
                        chatCustomerId: chatCustomerId,
                        msgId: msgId,
                    };
                    livePersonMessagesStatusManager.updatePendingMessageStatus(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, submitMessageToLivePerson({
                                        requestOptions: {
                                            url: submitMessageURL,
                                            headers: {},
                                        },
                                        livePersonMessagePayload: livePersonMessagePayload,
                                        handleLivePersonOnMessageError: handleLivePersonOnMessageError,
                                    })];
                                case 1:
                                    _a.sent();
                                    livePersonMessagesStatusManager.clearPendingAgentSequenceIds();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                } }))));
};
//# sourceMappingURL=ChatDialogContent.js.map